module.exports = __webpack_public_path__ + "40d24c1270d083df14890c011054d034.svg";